import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';


import { DescargarInterfazComponent } from './DesacargarInterfaz.component';

import { RoleGuardService as RoleGuard } from '../Seguridad/role-guard.service';


const routes = [
{
    path     : 'DescargarInterfaz',
    component: DescargarInterfazComponent,
    canActivate: [RoleGuard], 
    data: { 
        formulario: 'DescargarInterfaz',
        nombreFormulario : 'DescargarInterfaz'
    } 
}
];

@NgModule({
    declarations: [
        DescargarInterfazComponent
    ],
    imports     : [
    SharedModule,
    RouterModule.forChild(routes)
    ],
    exports     : [
        DescargarInterfazComponent
    ],
    bootstrap: [DescargarInterfazComponent],
})

export class DescargarInterfazModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/DescargarInterfaz/DescargarInterfaz.module.ts